import React, { Fragment } from 'react';
import { Link } from 'react-router-dom';

import PropTypes from 'prop-types';

import Social from './social';
import './footer-boton.css';

const FooterBoton = (props) => {
  return (
    <div className={`footer-boton-footer ${props.rootClassName} `}>
      <span className='footer-boton-text1'>{props.text}</span>
      <div className='footer-boton-content'>
        <div className='footer-boton-information'>
          <img
            alt={props.pastedImageAlt}
            src='/boton_logo/boton%20white-200h.png'
            className='footer-boton-pasted-image'
          />
          <div className='footer-boton-socials'>
            <a
              href='https://www.linkedin.com/company/herofacturas/'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-link10'
            >
              <Social
                rootClassName='socialroot-class-name'
                className='footer-boton-component1'
              ></Social>
            </a>
            <a
              href='https://www.instagram.com/botonapp/'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-link11'
            >
              <Social
                insiderSrc='/external/pastedimage-k0l6.svg'
                rootClassName='socialroot-class-name1'
                className='footer-boton-component2'
              ></Social>
            </a>
            <a
              href='https://wa.me/50765758641?text=Estoy%20interesado%20en%20hacer%20mi%20contabilidad%20con%20inteligencia%20artificial'
              target='_blank'
              rel='noreferrer noopener'
            >
              <img
                src='/whatsapp.png'
                className='whatsapp-icon'
                alt='WhatsApp'
              />
            </a>
          </div>
          <div className='footer-boton-container1'>
            <span className='footer-boton-text2'>{props.location}</span>
            <span className='footer-boton-text3'>{props.location1}</span>
            <Link to='/legal' className='footer-boton-navlink'>
              {props.location11}
            </Link>
            <Link to='/blog' className='footer-boton-navlink'>
              Blog
            </Link>
          </div>
        </div>
        <div className='footer-boton-links1'>
          <div className='footer-boton-column1'>
            <span className='footer-boton-header1'></span>
            <a
              href='https://www.ycombinator.com/companies/hero'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-acerca-de1'
            >
              {props.link5111}
            </a>
            <span className='footer-boton-noticias1'>
              {props.noticias111 ?? (
                <Fragment>
                  <a
                    href='https://www.prensa.com/martes-financiero/panamena-hero-impulsada-por-y-combinator/'
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    <span className='footer-boton-noticias3'>
                      <span>En las noticias</span>
                    </span>
                  </a>
                </Fragment>
              )}
            </span>
            <span className='footer-boton-precios1'>{props.precios111}</span>
            <a
              href='https://api.whatsapp.com/send?phone=50766181519'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-trabaja-con-nosotros1'
            >
              {props.trabajaConNosotros1111 ?? (
                <Fragment>
                  <a
                    href='https://api.whatsapp.com/send?phone=66181519'
                    target='_blank'
                    rel='noreferrer noopener'
                  >
                    <span className='footer-boton-trabaja-con-nosotros6'>
                      <span>Trabaja en Hero</span>
                    </span>
                  </a>
                </Fragment>
              )}
            </a>
          </div>
          <div className='footer-boton-column2'>
            <span className='footer-boton-header2'>{props.header111}</span>
            <a
              href='https://www.ycombinator.com/companies/hero'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-link12'
            >
              <img
                alt={props.imageAlt211}
                src='/external/yc_logo-200h-200h.png'
                className='footer-boton-image1'
              />
            </a>
            <a
              href='https://www.ycombinator.com/companies/hero'
              target='_blank'
              rel='noreferrer noopener'
              className='footer-boton-link13'
            >
              <img
                alt={props.imageAlt1111}
                src='/external/pioneer-200h-200h.jpeg'
                className='footer-boton-image2'
              />
            </a>
          </div>
        </div>
        <div className='footer-boton-container2'>
          <div className='footer-boton-links2'>
            <div className='footer-boton-column3'>
              <span className='footer-boton-header3'></span>
              <a
                href='https://www.ycombinator.com/companies/hero'
                target='_blank'
                rel='noreferrer noopener'
                className='footer-boton-acerca-de2'
              >
                {props.link5}
              </a>
              <span className='footer-boton-noticias2'>
                {props.noticias ?? (
                  <Fragment>
                    <a
                      href='https://www.prensa.com/martes-financiero/panamena-hero-impulsada-por-y-combinator/'
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      <span className='footer-boton-noticias4'>
                        <span>En las noticias</span>
                      </span>
                    </a>
                  </Fragment>
                )}
              </span>
              <span className='footer-boton-precios2'>{props.precios}</span>
              <a
                href='https://api.whatsapp.com/send?phone=50766181519'
                target='_blank'
                rel='noreferrer noopener'
                className='footer-boton-trabaja-con-nosotros2'
              >
                {props.trabajaConNosotros1 ?? (
                  <Fragment>
                    <a
                      href='https://api.whatsapp.com/send?phone=66181519'
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      <span className='footer-boton-trabaja-con-nosotros4'>
                        Trabaja en BOTON
                      </span>
                    </a>
                  </Fragment>
                )}
              </a>
              <span className='footer-boton-trabaja-con-nosotros3'>
                {props.trabajaConNosotros12 ?? (
                  <Fragment>
                    <a
                      href='https://api.whatsapp.com/send?phone=66181519'
                      target='_blank'
                      rel='noreferrer noopener'
                    >
                      <span className='footer-boton-trabaja-con-nosotros5'>
                        Formerly My Task Hero, Inc.
                      </span>
                    </a>
                  </Fragment>
                )}
              </span>
            </div>
          </div>
          <div className='footer-boton-links3'>
            <div className='footer-boton-column4'>
              <span className='footer-boton-header4'>{props.header11}</span>
              <a
                href='https://www.ycombinator.com/companies/hero'
                target='_blank'
                rel='noreferrer noopener'
                className='footer-boton-link14'
              >
                <img
                  alt={props.imageAlt21}
                  src='/external/yc_logo-200h-200h.png'
                  className='footer-boton-image3'
                />
              </a>
              <a
                href='https://www.ycombinator.com/companies/hero'
                target='_blank'
                rel='noreferrer noopener'
                className='footer-boton-link15'
              >
                <img
                  alt={props.imageAlt111}
                  src='/external/pioneer-200h-200h.jpeg'
                  className='footer-boton-image4'
                />
              </a>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

FooterBoton.defaultProps = {
  rootClassName: '',
  noticias111: undefined,
  imageAlt1111: 'image',
  pastedImageAlt: 'pastedImage',
  imageAlt21: 'image',
  text: '© 2024 All Rights Reserved. HELIO UAV, S.A.',
  location11: 'Términos y condiciones',
  precios: 'Precios',
  imageAlt211: 'image',
  location: 'Panamá, San Francisco, PH Gran Plaza',
  header11: 'Impulsados por',
  noticias: undefined,
  header111: 'Impulsados por',
  precios111: 'Precios',
  location1: 'Contáctanos a: soporte@botonapp.com',
  link5111: 'Acerca de',
  trabajaConNosotros1: undefined,
  trabajaConNosotros12: undefined,
  link5: 'Acerca de',
  trabajaConNosotros1111: undefined,
  imageAlt111: 'image',
};

FooterBoton.propTypes = {
  rootClassName: PropTypes.string,
  noticias111: PropTypes.element,
  imageAlt1111: PropTypes.string,
  pastedImageAlt: PropTypes.string,
  imageAlt21: PropTypes.string,
  text: PropTypes.string,
  location11: PropTypes.string,
  precios: PropTypes.string,
  imageAlt211: PropTypes.string,
  location: PropTypes.string,
  header11: PropTypes.string,
  noticias: PropTypes.element,
  header111: PropTypes.string,
  precios111: PropTypes.string,
  location1: PropTypes.string,
  link5111: PropTypes.string,
  trabajaConNosotros1: PropTypes.element,
  trabajaConNosotros12: PropTypes.element,
  link5: PropTypes.string,
  trabajaConNosotros1111: PropTypes.element,
  imageAlt111: PropTypes.string,
};

export default FooterBoton;
